<ng-container *transloco="let t">
  <!-- Loading bar -->
  <fuse-loading-bar></fuse-loading-bar>

  <!-- Navigation -->
  <!-- cdkOverlayOrigin
  #originNavigation="cdkOverlayOrigin"
  [ngClass]="{ 'heighlited-box': isOpenOriginNavigation }" -->
  <fuse-vertical-navigation
    id="navigation"
    class="dark bg-accent print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
    >
    <!-- fuseVerticalNavigationContentHeader -->
    <!-- Navigation header hook -->
    @if (user) {
      <ng-container fuseVerticalNavigationHeader>
        <!-- <div class="flex items-center w-full p-4 pl-6"> -->
        <div class="flex items-start w-full p-4 pl-6">
          <!-- Logo -->
          <div class="flex items-center justify-center">
            <!-- <img class="w-8" src="assets/images/logo/logo.svg" /> -->
            <img
              class="mt-2 w-32"
              [src]="'logo-panel' | assetsSource"
              />
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
              <!-- <notifications></notifications> -->
              <user [showAvatar]="false"></user>
            </div>
          </div>
          <!-- User -->
          @if (false) {
            <div class="flex flex-col items-center w-full p-4">
              <div class="relative w-24 h-24">
                <!-- <img
                class="w-full h-full rounded-full"
                *ngIf="user.avatar"
                [src]="user.avatar"
                alt="User avatar"
                /> -->
                <mat-icon
                  class="icon-size-24"
                  [svgIcon]="'heroicons_solid:user-circle'"
                ></mat-icon>
              </div>
              <div
                class="flex flex-col items-center justify-center w-full mt-6"
                >
                <div
                  class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium"
                  >
                  {{ user.firstName }}
                </div>
                <div
                  class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary"
                  >
                  {{ user.email }}
                </div>
              </div>
            </div>
          }
        </ng-container>
      }
      <!-- Navigation footer hook -->
      <ng-container fuseVerticalNavigationContentFooter>
        <div
          class="flex flex-none items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12"
          >
          <!-- <img class="max-w-36" src="assets/images/logo/logo_adele.png" /> -->
        </div>
      </ng-container>
    </fuse-vertical-navigation>

    <!-- <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="originNavigation"
    [cdkConnectedOverlayOpen]="isOpenOriginNavigation"
    (detach)="isOpenOriginNavigation = false"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    >
    <div id="navigation" class="overlay-container">
      Navigation.
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="next('help-center')"
        >
        Next
      </button>
    </div>
  </ng-template> -->

  <!-- support.help-center -->

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
      class="relative flex flex-none items-center w-full h-16 px-4 md:px-6 z-49 shadow-sm dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
      >
      <!-- Navigation toggle button -->
      <button
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
        >
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>

      <!-- cdkOverlayOrigin
      #originAccountSelector="cdkOverlayOrigin"
      [ngClass]="{ 'heighlited-box': isOpenAccountSelector }" -->
      <!-- <div #targetElement> -->
      <account-selector
        id="account-selector"
        class="w-80 mt-4"
      ></account-selector>
    <!-- </div> -->
    <!-- <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="originAccountSelector"
    [cdkConnectedOverlayOpen]="isOpenAccountSelector"
    (detach)="isOpenAccountSelector = false"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    >
    <div class="overlay-container">
      This is an account selector.
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="next('navigation')"
        >
        Next
      </button>
    </div>
  </ng-template> -->

  <!-- Components -->
  <div
    class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2"
    >
    <img class="max-w-40 mr-2" [src]="'logo2' | assetsSource" />
    <languages></languages>
    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
    <!-- <button
    class="lg:hidden"
    mat-icon-button
    (click)="quickChat.toggle()"
    >
    <mat-icon
      [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
    ></mat-icon>
  </button> -->
</div>
</div>

<!-- Content -->
<div class="flex flex-col flex-auto">
  <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
  @if (true) {
    <router-outlet></router-outlet>
  }
</div>

<!-- Footer -->
<!--<div class="relative flex flex-none items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
<span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
</div>-->
</div>

<!-- <div #targetElement class="target-box">Target Container Element</div> -->

<!-- Template definition to be injected into the overlay -->
<ng-template #overlayTemplate>
  <div class="custom-overlay-panel">
    @if (isOpenAccountSelector) {
      <p class="mb-4">
        Willkommen bei ADELE! Wähle zuerst hier den richtigen ADELE
        Nutzer aus.
      </p>
      <div class="flex justify-end items-center">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="skip('account-selector')"
          >
          Überspringen
        </button>
        <button
          class="ml-2"
          type="button"
          mat-flat-button
          color="primary"
          (click)="nextStep('navigation')"
          >
          Weiter
        </button>
      </div>
    }
    @if (isOpenOriginNavigation) {
      <p class="mb-4">
        Hier dreht sich alles um Dich! Damit ADELE Dich optimal
        unterstützen kann, sind hier alle Deine persönlichen
        Informationen hinterlegt, die wir schon zusammen eingegeben
        haben – von Deinen Kontakten bis hin zum WLAN.
        <br />
        Prüfe einfach, ob alles auf dem neuesten Stand ist, und
        passe es jederzeit an. So kann ADELE Dir immer so helfen,
        wie es am besten zu Dir passt.
      </p>
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="skip('navigation')"
        >
        Überspringen
      </button>
      <button
        class="ml-2"
        type="button"
        mat-flat-button
        color="primary"
        (click)="nextStep('help-center')"
        >
        Weiter
      </button>
    }
    @if (isOpenOriginHelpCenter) {
      <p class="mb-4">
        Entdecke ADELE – hier im Hilfe-Center findest Du alles, was
        Du für den Einstieg brauchst. Von hilfreichen FAQs bis hin
        zu praktischen Video-Anleitungen. Bereit? Los gehts!
      </p>
      <div class="flex justify-end items-center">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="skip('support.help-center')"
          >
          Überspringen
        </button>
        <button
          class="ml-2"
          type="button"
          mat-flat-button
          color="primary"
          (click)="nextStep('done')"
          >
          Weiter
        </button>
      </div>
    }
  </div>
</ng-template>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
</ng-container>
